import { store } from '@webplatform/frontkit';

export default () => store({});
